var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('servenav',{attrs:{"immersive":"true","toggleQrcode":_vm.toggleQrcode,"scrollTo":_vm.scrollTo,"scrollTop":_vm.scrollTop,"direction":_vm.direction,"activeNav":_vm.activeNav}}),_c('div',{style:({ height: _vm.clientWidth < 992 ? `64px` : `72px` })}),_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }